import SignAgreement from './SignAgreement';

export default SignAgreement;
